import React from 'react';

const Item = ({item, icons}) => {
    return <li className={'functionality_item'}>
        <div className={'functionality_item_wrapper'}>
            {icons[item.icon]}
            <h3 className={'functionality_item_title'}>{item.title}</h3>
            <p className={'functionality_item_description'}>{item.description}</p>
        </div>
    </li>
}

const Functionality = ({functionality, icons}) => {

    return (
        <section className={'functionality'}>
            <div className="container">
                <div className="functionality_wrapper">
                    <div className="functionality_title">
                        <span className={'functionality_title_label'}>{functionality.label}</span>
                        <h2 className={'functionality_title_title'}>{functionality.title}</h2>
                        <p className={'functionality_title_description'}>{functionality.description}</p>
                    </div>
                    <div className="functionality_items_wrapper">
                        <ul className={'functionality_items'}>
                            {functionality.items_1.map(item => {
                                return <Item
                                    key={item.key}
                                    item={item}
                                    icons={icons}
                                />
                            })}
                        </ul>
                        <ul className={'functionality_items'}>
                            {functionality.items_2.map(item => {
                                return <Item
                                    key={item.key}
                                    item={item}
                                    icons={icons}
                                />
                            })}
                        </ul>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Functionality;